export enum RestMethods {
	POST = 'POST',
	GET = 'GET',
	PATCH = 'PATCH',
	PUT = 'PUT',
	DELETE = 'DELETE'
}
